/* @flow */
import * as React from 'react';

const Chemicals = props => (
  <svg
    width={103}
    height={93}
    viewBox="0 0 103 93"
    fillRule="evenodd"
    strokeWidth={3}
    fill="none"
    strokeLinecap="round"
    {...props}>
    <path
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      d="M65.56,74.741 L65.56,36.268 L6.673,36.268 L6.673,85.577 C6.673,88.615 9.137,91.079 12.175,91.079 L60.058,91.079 C61.922,91.079 63.569,90.152 64.564,88.735"
    />
    <path
      stroke="#3A427C"
      d="M65.56,74.741 L65.56,36.268 L6.673,36.268 L6.673,85.577 C6.673,88.615 9.137,91.079 12.175,91.079 L60.058,91.079 C61.922,91.079 63.569,90.152 64.564,88.735"
      strokeLinejoin="round"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M58.863,67.239 C58.863,60.943 48.679,55.838 36.116,55.838 C23.553,55.838 13.369,60.943 13.369,67.239 C13.369,73.535 23.553,78.64 36.116,78.64 C48.679,78.64 58.863,73.535 58.863,67.239"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      d="M57.479,36.82 L57.479,48.629 L41.772,76.814 C41.746,76.861 41.721,76.91 41.7,76.961 C40.199,80.453 40.552,84.432 42.643,87.605 C44.733,90.779 48.25,92.673 52.05,92.673 L60.882,92.673 L60.882,36.82 L57.479,36.82 Z"
      opacity={0.2}
    />
    <path
      stroke="#1C1F34"
      d="M65.56,74.741 L65.56,36.268 L6.673,36.268 L6.673,85.577 C6.673,88.615 9.137,91.079 12.175,91.079 L60.058,91.079 C61.922,91.079 63.569,90.152 64.564,88.735"
      strokeLinejoin="round"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#EA7471"
      d="M34.62,36.267 L31.815,36.267 L24.101,36.267 L21.296,36.267 L16.386,36.267 L16.386,58.804 C16.386,60.934 18.113,62.661 20.243,62.661 C22.374,62.661 24.101,60.934 24.101,58.804 L24.101,44.092 L24.101,44.066 C24.101,41.936 25.828,40.209 27.958,40.209 C30.088,40.209 31.815,41.936 31.815,44.066 L31.815,44.092 C31.815,46.222 33.542,47.949 35.672,47.949 C37.802,47.949 39.529,46.222 39.529,44.092 L39.529,36.267 L34.62,36.267 Z"
    />
    <path
      stroke="#1C1F34"
      d="M34.62,36.267 L31.815,36.267 L24.101,36.267 L21.296,36.267 L16.386,36.267 L16.386,58.804 C16.386,60.934 18.113,62.661 20.243,62.661 C22.374,62.661 24.101,60.934 24.101,58.804 L24.101,44.092 L24.101,44.066 C24.101,41.936 25.828,40.209 27.958,40.209 C30.088,40.209 31.815,41.936 31.815,44.066 L31.815,44.092 C31.815,46.222 33.542,47.949 35.672,47.949 C37.802,47.949 39.529,46.222 39.529,44.092 L39.529,36.267 L34.62,36.267 Z"
      strokeLinejoin="round"
    />
    <path
      stroke="#1C1F34"
      d="M62.99,14.295 C56.643,6.488 46.962,1.5 36.116,1.5 C16.998,1.5 1.5,16.998 1.5,36.117 L1.5,41.635 L5.844,41.635"
      strokeLinejoin="round"
    />
    <polyline
      stroke="#3A427C"
      strokeLinejoin="round"
      points="66.389 41.635 70.733 41.635 70.733 36.117"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#FFFFFF"
      d="M84.194,20.257 L62.262,20.257 L62.262,49.043 L46.354,77.59 C43.611,83.972 48.292,91.079 55.238,91.079 L91.217,91.079 C98.164,91.079 102.845,83.972 100.102,77.59 L84.194,49.043 L84.194,20.257 Z"
    />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#9EA1AE"
      d="M51.541,69.014 C51.541,69.014 54.398,65.566 66.143,68.703 C75.965,71.327 88.98,71.022 93.66,65.206 L99.863,76.813 C99.863,76.813 102.289,81.423 99.297,86.612 C96.304,91.801 84.815,91.078 84.815,91.078 L55.889,91.078 C55.889,91.078 47.845,91.285 45.868,83.635 C43.891,75.985 51.541,69.014 51.541,69.014"
    />
    <path stroke="#DEDEDE" d="M56.852,59.373 L61.796,59.373" />
    <path stroke="#DEDEDE" d="M62.261,49.043 L67.205,49.043" />
    <path stroke="#DEDEDE" d="M62.261,38.713 L67.205,38.713" />
    <path stroke="#DEDEDE" d="M62.261,28.383 L67.205,28.383" />
    <path
      stroke="none"
      strokeWidth={1}
      fill="#283060"
      d="M98.377,76.96 C98.355,76.91 98.331,76.861 98.305,76.814 L82.599,48.629 L82.599,20.257 C82.599,19.377 81.885,18.663 81.005,18.663 L67.736,18.663 C67.986,19.292 68.139,20.001 68.154,20.8 C68.161,21.149 68.168,21.501 68.176,21.851 L79.411,21.851 L79.411,49.043 C79.411,49.315 79.48,49.582 79.612,49.82 L92.478,78.292 C93.519,80.778 93.258,83.598 91.772,85.851 C90.274,88.126 87.753,89.485 85.029,89.485 L83.505,89.485 C83.417,90.607 86.037,91.725 85.404,92.673 L88.029,92.673 C91.829,92.673 95.345,90.779 97.436,87.605 C99.526,84.431 99.878,80.452 98.377,76.96"
      opacity={0.2}
    />
    <path
      stroke="#1C1F34"
      d="M84.194,20.257 L62.262,20.257 L62.262,49.043 L46.354,77.59 C43.611,83.972 48.292,91.079 55.238,91.079 L91.217,91.079 C98.164,91.079 102.845,83.972 100.102,77.59 L84.194,49.043 L84.194,20.257 Z"
      strokeLinejoin="round"
    />
    <path stroke="none" strokeWidth={1} fill="#FFFFFF" d="M84.194,20.257 L87.712,20.257" />
    <path stroke="#1C1F34" d="M84.194,20.257 L87.712,20.257" strokeLinejoin="round" />
  </svg>
);

export default Chemicals;



// WEBPACK FOOTER //
// ./src/assets/images/icons/chemicals.js